// 漫畫 一行兩個
import { CmsGridWrapper } from 'commonStyledComponents'
import ComicBox from 'component/ComicBox'
import { memo } from 'react'

interface Template201Props {
  videoData?: any[]
  trigger?: React.ReactNode
  currentLimit?: number
  lazy?: boolean
}

/**
 * 模板 ID: "201": 豎版一行兩個
 * */
function Template201({ videoData, trigger, currentLimit, lazy = false }: Template201Props) {
  return (
    <CmsGridWrapper>
      {videoData?.slice(0, currentLimit).map((item, i) => {
        return <ComicBox overflow={true} columns={2} key={i} comicInfo={item} allowUnload />
      })}
      {trigger}
    </CmsGridWrapper>
  )
}

// this indicate areaBox should hide bottom section until fully shown
;(Template201 as any).lazy = true
export default memo(Template201)
